const map_US_Locale = {
    'map.contactPhone': 'Contact Phone：',
    'map.contactPhoneContent': '0755-8696 9948',
    'map.contactEmail': 'Contact Email：',
    'map.contactAddress': 'Contact Address：',
    'map.contactAddressContent': '16th Floor, Building D,Nanshan Zhiyuan, 1001 Xueyuan Avenue, Changyuan Community, Taoyuan Street, Nanshan District, Shenzhen',
    'map.workingHours': 'Working Hours：',
    'map.workingHoursContent': 'Monday to Friday',
    'map.workingHoursContent1': '(9:00 AM - 6:30 PM)',
    'map.consultation': 'Feel free to call us for inquiries!'
}
export default map_US_Locale
